<template>
  <div class='container center-container'>

    <div class='pic-box' v-if='pic_url'>
      <img class="pic" :src="pic_url"  />
      <!-- <video v-if='video_id === 1' autoplay loop :controls='false' src="https://s.desmix.com/nike/fs/Structure.mp4" webkit-playsinline='true' playsinline='true' x5-playsinline='true' />
      <video v-if='video_id === 2' autoplay loop :controls='false' src="https://s.desmix.com/nike/fs/Pegasus.mp4" webkit-playsinline='true' playsinline='true' x5-playsinline='true' /> 
      <video v-if='video_id === 3' autoplay loop :controls='false' src="https://s.desmix.com/nike/fs/Vomero.mp4" webkit-playsinline='true' playsinline='true' x5-playsinline='true' />
      <div class='bc'></div> -->
    </div>

    <!-- <img class="shadow" v-if='pic_url' src="../assets/image/shadow.png" /> -->
    <div class="btn bottom-btn" v-if='pic_url' @click='downloadPic' :class="{en: language=== 'EN'}">{{ language === 'TC' ? '下載' : 'Download' }}</div>


  </div>
</template>

<script>
  import axios from 'axios'

  export default {

    data () {
      return {
        pic_url: '',
        video_id: 0,
        
      }
    },
    mounted(){
      this.getPlayInfo()

    },

    methods: {
      getPlayInfo() {
        var me = this

        if (this.timestamp) {
          axios({
            method: 'get',
            url: me.baseUrl + '/scanner/' + me.timestamp,
          }).then(res => {

            if (res.status === 200 && res.data.data && res.data.data.pic_url) { 
              me.pic_url = res.data.data.pic_url
              me.video_id = res.data.data.video_id
            }

          }).catch(e => {
            console.log('getPlayInfo-e :>> ', e)
          })
        
        } else if (this.openid) {
          axios({
            method: 'get',
            url: me.baseUrl + '/scanner/users/' + me.openid,
          }).then(res => {
            if (res.status === 200 && res.data.data && res.data.data.length) { // 游戏开始
              res.data.data.sort(function(a,b) {
                return new Date(b.play_time).getTime() - new Date(a.play_time).getTime()
              })
              me.pic_url = res.data.data[0].pic_url
              me.video_id = res.data.data[0].video_id

            }
      

          }).catch(e => {
            console.log('getPlayInfo-e :>> ', e)
          })
        }

        

      },


      downloadPic() {
        var filename; //图片名称
        var filetype; //图片类型
        var path = this.pic_url
        if (path.indexOf("/") > 0) {
          var file = path.substring(path.lastIndexOf("/") + 1, path.length)
          var fileArr = file.toLowerCase().split(".");
          filename = fileArr[0];
          filetype = fileArr[1];
        }
        let image = new Image();
        image.setAttribute("crossOrigin", "anonymous");
        image.crossOrigin = '*'  // 解决跨域
        image.onload = function () {
            let canvas = document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            let context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            let img = canvas.toDataURL(`image/${filetype}`); //得到图片的base64编码数据
            let a = document.createElement("a"); // 生成一个a元素
            let event = new MouseEvent("click"); // 创建一个单击事件
            a.download = filename; // 设置图片名称，-------------你传递的图片名称
            a.href = img  // 将生成的URL设置为a.href属性
            a.dispatchEvent(event); // 触发a的单击事件
        }
        image.src = path + '?v=' + Math.random();// 防止缓存

        if (liff.isInClient()) {
          liff.openWindow({
            url: this.pic_url,
            external: true
          })
        }
      },

    },

    computed: {
      language() {
        return this.$store.state.language
      },
      timestamp() {
        return this.$store.state.timestamp
      },
      baseUrl() {
        return this.$store.state.baseUrl
      },
      openid() {
        return this.$store.state.openid
      },
      
    },

  }
</script>


<style lang="less" scoped>

  .center-container {
    background-color: #fff;
    position: relative;
    overflow-y: auto;
  }

  .pic-box {
    position: relative;
    margin: 13.33vw 0 0 0;
    width: 100%;
    .pic {
      width: 100%;
    }
    video {
      position: absolute;
      z-index: 5000;
      width: 93.3vw;
      left: 3.35vw;
      top: 680vw;
    }
    .bc {
      position: absolute;
      z-index: 10;
      width: 93.3vw;
      left: 3.35vw;
      top: 681.33vw;
      height: 68vw;
      background-color: #000;
    }

  }

  

  .shadow {
    position: fixed;
    bottom: 0px;
    left: 0;
    width: 100%;
    height: 24vw;
    z-index: 10;
    // background: linear-gradient( 185deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.88) 92%);
  }

  
  .bottom-btn {
    position: fixed;
    z-index: 20;
    bottom: 7vw;
    width: 89.4vw;
    height: 10.67vw;
    left: 5.3vw;
    background-color: #000;
    color: #fff;
    text-align: center;
    line-height: 10.67vw;
    font-size: 3.2vw;
    font-weight: bold;
    border-radius: 50px;
    font-family: 'fs-bold';
    &.en {
      font-family: 'en-bold';
    }
  }




</style>



// WEBPACK FOOTER //
// src/pages/user_center.vue